let _BASE_NAME = '';
//TODO: Once data is in prod we need to set this correctly to prod
if (process && process.env.REACT_APP_ENV === 'staging') {
    _BASE_NAME = '/services/sandbox/stage/index.html';

}
export const BASE_NAME = _BASE_NAME;

